import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlanForm from '../containers/PlanFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlanAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlanAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('plans_route_add')} />
          <PlanForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlanAddScreen;

Logger.log('silly', `PlanAddScreen loaded.`);
